<ng-template #link let-link>
  @if (link.routerLink) {
    <a
      class="text-sm leading-normal text-light-on-navy/80 transition-colors hover:text-light-on-navy"
      [routerLink]="link.routerLink">
      {{ link.label | translate }}
    </a>
  } @else {
    <a
      class="text-sm leading-normal text-light-on-navy/80 transition-colors hover:text-light-on-navy"
      [href]="link.href">
      {{ link.label | translate }}
    </a>
  }
</ng-template>

<!-- tracking-normal and m-0: the app sets letter-spacing and paragraph margins globally. -->
<footer
  class="bg-light-navy border-t border-light-on-navy/10 tracking-normal text-base leading-normal">
  <div
    class="max-w-[1512px] mx-auto px-4 sm:px-8 lg:px-site-gutter-lg xl:px-site-gutter-xl py-12 lg:py-16">
    <div
      class="grid grid-cols-2 lg:grid-cols-[1fr_auto_auto_auto] gap-x-8 gap-y-8 lg:gap-x-20 lg:gap-y-10">
      <div class="col-span-2 lg:col-span-1 flex flex-col gap-6">
        <a [href]="baseUrl" class="flex flex-col w-fit items-start gap-1">
          <img
            src="assets/brand/logo-blue.svg"
            alt="Bildigsnetz"
            width="97"
            height="22"
            class="w-[97px] h-[22px] object-contain" />
          <span
            class="flex items-center gap-1 pl-footer-sublabel"
            aria-hidden="true">
            <span class="size-[3px] rounded-full bg-light-primary"></span>
            <img alt="" src="assets/brand/bildungsstellen.svg" class="h-2" />
          </span>
        </a>
        <p class="m-0 text-footer-intro max-w-[240px] text-light-on-navy/80">
          {{ 'footer.claim' | translate }}
        </p>
        <div class="flex gap-3">
          @for (s of social; track s.alt) {
            <a
              [href]="s.href"
              target="_blank"
              rel="noopener noreferrer"
              class="size-9 rounded-[10px] border border-light-on-navy/15 flex items-center justify-center transition-colors hover:border-light-on-navy/40">
              <img
                [src]="s.icon"
                [alt]="s.alt"
                width="16"
                height="16"
                class="size-4 object-contain" />
            </a>
          }
        </div>
      </div>

      <div class="flex flex-col gap-4">
        <p
          class="m-0 text-xs leading-normal font-semibold tracking-[1.2px] uppercase text-light-on-navy">
          {{ 'footer.platform' | translate }}
        </p>
        <ul class="m-0 p-0 list-none flex flex-col gap-3">
          @for (l of platform; track l.label) {
            <li>
              <ng-container
                *ngTemplateOutlet="link; context: { $implicit: l }" />
            </li>
          }
        </ul>
      </div>

      <div class="lg:contents flex flex-col justify-between">
        @for (col of columns; track col.heading) {
          <div class="flex flex-col gap-4">
            <p
              class="m-0 text-xs leading-normal font-semibold tracking-[1.2px] uppercase text-light-on-navy">
              {{ col.heading | translate }}
            </p>
            <ul class="m-0 p-0 list-none flex flex-col gap-3">
              @for (l of col.links; track l.label) {
                <li>
                  <ng-container
                    *ngTemplateOutlet="link; context: { $implicit: l }" />
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <div
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 mt-10 lg:mt-14 pt-8 border-t border-light-on-navy/10">
      <p class="m-0 text-sm leading-normal text-light-on-navy/80">
        {{ 'footer.copyright' | translate: { year } }}
      </p>
      <p class="m-0 text-sm leading-normal text-light-on-navy/80">
        Mensch &amp; Bildung GmbH
      </p>
    </div>
  </div>
</footer>
